/** @flow */

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader, GSGrid } from "@components";
import { formatDate } from "@transformers/date";
import type { AbsenceRateExclusion } from "../../reducer/trends/absence-rate/types";

type Props = $Exact<{
  ...PropsFromLocalize,
  exclusions: Array<AbsenceRateExclusion>,
  onDismissHandler: () => void,
}>;

export class TrendAbsenceRateExclusionsModal extends React.Component<Props> {
  get exclusionData() {
    return (this.props.exclusions || []).map(exclusion => ({
      absenceReason: exclusion.absenceReason.label,
      dateExcluded: formatDate(exclusion.excludeFrom),
    }));
  }

  render() {
    return (
      <Modal>
        <ModalHeader>{this.props.t("TRENDS_ABSENCE_RATE_EXCLUSIONS")}</ModalHeader>
        <ModalBody>
          <GSGrid
            columns={[
              {
                key: "absenceReason",
                name: this.props.t("REPORT_FILTER_ABSENCE_REASON"),
              },
              {
                key: "dateExcluded",
                name: this.props.t("TRENDS_ABSENCE_RATE_DATE_EXCLUDED"),
              },
            ]}
            rows={this.exclusionData}
          />
          <div className="d-flex justify-content-end">
            <Button materialIcon="replay_circle_filled" onClick={this.props.onDismissHandler}>
              {this.props.t("SUBMIT")}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default localize()(TrendAbsenceRateExclusionsModal);
